import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule, LazyAction, type LazyComponent } from 'owa-bundling';

import { launchDomainConnectSetAlias } from './orchestrator/launchCreateEmailFromPopout';
import type {
    DomainConnectProps,
    DomainConnectSecondStep,
} from './components/DomainConnectSecondStep';
import type {
    DomainConnectFirstStepProps,
    DomainConnectFirstStep,
} from './components/DomainConnectFirstStep';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "OwaMailDomainConnect" */ './lazyIndex'),
    { name: 'OwaMailDomainConnect' }
);

export const PremiumDomainConnectFirstStep: LazyComponent<
    DomainConnectFirstStepProps,
    DomainConnectFirstStep,
    void
> = createLazyComponent(lazyModule, m => m.DomainConnectFirstStep);
export const PremiumDomainConnectSecondStep: LazyComponent<
    DomainConnectProps,
    DomainConnectSecondStep,
    void
> = createLazyComponent(lazyModule, m => m.DomainConnectSecondStep);

export const lazyMountAndShowDCSecondStep: LazyAction<
    typeof lazyIndex.mountAndShowDCSecondStep,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.mountAndShowDCSecondStep);

if (typeof window !== 'undefined' && typeof window.Owa !== 'undefined') {
    window.Owa.launchDomainConnectSetAlias = launchDomainConnectSetAlias;
}
